import { isSameDay, parseISO } from 'date-fns';
import { formatDateFromTodayOnlyDifference } from './formatDateFromTodayOnlyDifference.util';

export const formatPublishHistory = (approvalDate: string, updatedAt?: string | null) => {
  if (!approvalDate) {
    return '';
  }

  if (!updatedAt) {
    return `${formatDateFromTodayOnlyDifference(approvalDate)}`;
  }

  const createdDate = parseISO(approvalDate);
  const updatedDate = parseISO(updatedAt);

  const isCreatedDate = isSameDay(createdDate, updatedDate);
  const dateToDisplay = isCreatedDate ? approvalDate : updatedAt;
  const suffix = isCreatedDate ? '등록' : '수정';

  return `${formatDateFromTodayOnlyDifference(dateToDisplay)}`;
};
